<template>
  <list mode="file" :items="files" @load="onLoad" @delete="onDelete" />
</template>
<script>
import List from "@/components/list"
import Files from "@/api/files"
export default {
  name: "Files",
  components: { List },
  data() {
    return {
      files: {
        limit: 20,
        offset: 0,
        count: 0,
        results: []
      }
    }
  },
  methods: {
    onLoad() {
      if (this.files.count == 0 || this.files.offset < this.files.count) {
        this.setBusy(true)
        Files.list(this.files.offset).then(response => {
          this.files.count = response.data.count
          this.files.results.push(...response.data.results)
          this.files.offset += this.files.limit
        }).finally(() => this.setBusy(false))
      }
    },
    onDelete(items) {
      Files.delete({ items: items }).then(response => {
        this.notify(response.data)
        this.refresh()
      })
    }
  }
}
</script>
